// extracted by mini-css-extract-plugin
export default {"colleaguesTooltipList":"colleaguesTooltipList--ozQEo","colleaguesTooltipItem":"colleaguesTooltipItem--OpseH"};